export const background = '#F9F9F9';
export const brandHighlight = '#46C1EE';
export const brandHover = '#0DB7F5';
export const brandPrimary = '#00528C';
export const brandPrimaryActive = '#003C67';
export const brandPrimaryHover = '#046CB6';
export const brandSecondary = '#00AAE8';
export const brandSecondaryActive = '#029AD1';
export const brandSecondaryHover = '#0DB7F5';
export const error = '#B34755';
export const mention = '#E8F3F9';
export const mentionDark = '#CAE0EC';
export const nameCircles = '#D3DBDE';
export const navigation = '#A7ABAD';
export const success = '#89C947';
export const successTint = '#DBF2C3';
export const titles = '#0D0F11';
export const toggleOff = '#D0021B';
export const toggleOn = '#89C947';
export const urgentDate = '#D0021B';
